import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { Seo } from '../data/models/components/seo';
import { SeoService } from './seo.service';

@Component({
  selector: 'placeme-layout-seo',
  templateUrl: './layout-seo.component.html',
  styleUrls: ['./layout-seo.component.scss'],
})
export class LayoutSeoComponent implements OnChanges {
  @Input() category: string;
  @Input() seo: Seo;

  constructor(private seoService: SeoService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.seo) {
      this.seoService.set(this.seo, this.category);
    }
  }
}
